import React, { useContext, useState, useEffect } from 'react'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import SelectDrawerFilter from './child/SelectDrawerFilter'
import DateRangePicker from './child/DateRangePicker'
import FilterContext from '../utils/FilterContext'
import { getDefaultFiltersForRoute } from '../config/filterDeafault'
import { useLocation } from 'react-router-dom'
import Cookies from 'js-cookie';
const COOKIE_NAME = 'appFilters';

const DrawerFilter = ({ filterOptions = { showSelect: true, showDateRange: true, dateRangeConfig: {} } }) => {
    const [isOpen, setIsOpen] = React.useState(false)
    const selectRef = React.useRef(null) // Reference to access the reset function
    const selectDateRangeRef = React.useRef(null) // Reference to access the reset function
    const { filters, setFilters, routeFilters, updateRoutesFilters, getCurrentFilters, setIsInitialized } = useContext(FilterContext); // Get setFilters function from context
    const location = useLocation();
    const currentPath = location.pathname;


    //for initailly and when path change then set filters data  from cookie
    useEffect(() => {
        const cookieKey = `filters_${currentPath}`;
        const cookieFilter = Cookies.get(cookieKey);
        let saveFilter = {};
        const formatDate = (d) => {
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };


        if (cookieFilter && JSON.parse(cookieFilter)?.dateRange?.trim()) {
            // console.log("heheh", JSON.parse(cookieFilter))
            try {
                saveFilter = JSON.parse(cookieFilter);
                // updateRoutesFilters(currentPath, saveFilter);
                const isDifferent = JSON.stringify(saveFilter) !== JSON.stringify(filters);
                if (isDifferent) {
                    setFilters(saveFilter);
                }
            } catch (e) {
                console.error("Failed to parse cookie filter data", e);
            }
        }
        else {
            saveFilter = getDefaultFiltersForRoute(currentPath);
            // console.log("saveFilter", saveFilter)
            Cookies.set(cookieKey, JSON.stringify(saveFilter), { expires: 7 });
            setFilters(saveFilter);
        }
        // reset child UI if no saved filters
        if (!cookieFilter || Object.keys(saveFilter).length === 0) {
            if (selectRef.current) selectRef.current.resetSelections();
            if (selectDateRangeRef.current) selectDateRangeRef.current.resetSelections();
        }


    }, [currentPath]);


    // function for open and close drawer filter
    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState)
    }

    // function for refresh all value of filter
    const handleRefresh = () => {
        // for select 
        if (selectRef.current) {
            selectRef.current.resetSelections(); // Call reset function from child component
        }

        // for date range
        if (selectDateRangeRef.current) {
            selectDateRangeRef.current.resetSelections(); // Call reset function from child component
        }

    }

    const handleSubmit = () => {
        const selectData = selectRef.current?.getSelectedData() ?? {};
        const dateData = selectDateRangeRef.current?.getSelectedData() ?? {};


        const newFilters = {
            ...selectData,
            ...dateData,
        };

        // Save filters to a cookie with a path-specific key
        const cookieKey = `filters_${currentPath}`;
        Cookies.set(cookieKey, JSON.stringify(newFilters), { expires: 7 });


        // Update both global filters and route-specific filters
        setFilters(newFilters);
        // updateRoutesFilters(currentPath, newFilters);


        // console.log('Final Payload:', filters);

        // handleRefresh()
        toggleDrawer()


    };

    // ✅ Update state with count of non-empty values
    const validValuesCount = Object.values(filters).filter(value => value !== null && value !== undefined && value !== '').length;


    return (
        <>
            <style>
                {`
            .full-height-overlay {
                height: 100% !important;
            }
            `}
            </style>
            <button className='position-fixed d-inline drawer_filter' onClick={toggleDrawer}>
                <img src="assets/images/filter_4867881.png" alt="" />
                {validValuesCount > 0 && (
                    <span className="position-absolute top-0 start-0 translate-middle badge rounded-circle bg-danger border border-white">
                        {validValuesCount}
                    </span>
                )}
            </button>
            <Drawer
                open={isOpen}
                onClose={toggleDrawer}
                direction='right'
                className='bla bla bla'
                size={320}
                style={{ height: '100%' }}
                overlayClassName='full-height-overlay' // Add this prop

            >
                <div className="drawer-content">
                    <div className="drawer-header">
                        <i className="ri-refresh-line fw-bold fs-5 cursor-pointer" style={{ color: "#487fff" }} onClick={handleRefresh}></i>
                        <i className="ri-close-large-line fw-bold fs-5 cursor-pointer text-danger" onClick={toggleDrawer}></i>
                    </div>

                    <div className="drawer-body">
                        {filterOptions.showSelect && <SelectDrawerFilter ref={selectRef} />}
                        {filterOptions.showDateRange && (
                            <div className="mb-3 " style={{ padding: '15px' }}>
                                <label className="form-label">Select date</label>
                                <div className="d-flex justify-content-between date_picker_inpur">
                                    <DateRangePicker ref={selectDateRangeRef} config={filterOptions.dateRangeConfig} />
                                    <div className="css-1wy0on6">
                                        <span className="css-1u9des2-indicatorSeparator"></span>
                                        <div className="css-1xc3v61-indicatorContainer" aria-hidden="true">
                                            <svg
                                                height="20"
                                                width="20"
                                                viewBox="0 0 20 20"
                                                aria-hidden="true"
                                                focusable="false"
                                                className="css-tj5bde-Svg"
                                            >
                                                <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            // /* add more filters here  */
                        )}
                        <div className="mb-3 " style={{ padding: '15px' }}>
                            <button className="btn btn-primary w-100 " onClick={handleSubmit}>Submit</button>
                        </div>
                    </div>
                </div>
            </Drawer>
        </>
    )
}

export default DrawerFilter
